import React from 'react'
import HeaderNav from '../nav'
import { Link } from 'gatsby'
// import { LazyLoadImage } from 'react-lazy-load-image-component'
// import TeamImg from '../../images/team_new.png'

const Header = ({ siteTitle }) => (
  <div id="header">
    <div id="head_top">
      <div className="container">
        <div className="row">
          <div className="col col-md-6 col-sm-6 col-xs-12 mail">
            <a href="mailto:dan@armstrongrealestateco.com">
              <svg
                style={{
                  width: '24px',
                  height: '24px',
                  float: 'left',
                  display: 'inline-block',
                  'margin-right': '10px',
                }}
                viewbox="0 0 24 24"
              >
                <path
                  fill="#5456af"
                  d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4M12,11L20,6H4L12,11M4,18H20V8.37L12,13.36L4,8.37V18Z"
                />
              </svg>{' '}
              dan@armstrongrealestateco.com
            </a>
          </div>
          <div className="col col-md-6 col-sm-6 col-xs-12 social">
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/ArmstrongRealEstateCompany/"
                  target="_blank"
                  className="hvr-pulse"
                  rel="noopener noreferrer"
                >
                  <svg
                    style={{
                      width: '24px',
                      height: '24px',
                      float: 'left',
                      display: 'inline-block',
                      'margin-right': '10px',
                    }}
                    viewbox="0 0 24 24"
                  >
                    <path
                      fill="#6a6bcc"
                      d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="menu-container py-3">
      <div className="container">
        <div className="row d-flex align-items-center flex-nowrap">
          <div className="col-9 col-sm-6 col-md-3">
            <div className="nav-brand d-flex justify-content-start align-items-center">
              <Link to="/">
                <img src="/img/logo.png" alt="logo" />
              </Link>
            </div>
          </div>
          <div className="col-3 col-sm-auto col-md-9 d-flex justify-content-end align-items-center ml-auto text-center log_cont">
            <div className="d-sm-inline-block top-links">
              <ul>
                <li className="menu mt-1">
                  <Link to="/contact">Sell My Home</Link>
                </li>
                {/* <li className="menu">
                  <Link to="#team">Meet My Team</Link>
                </li> */}
                <li className="menu">
                  <Link to="/contact">Buy A Home</Link>
                </li>
                <li className="menu">
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>
            <HeaderNav />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Header
